import React, { useEffect } from 'react';
import { TrustpilotEmbedStyles as S } from './TrustpilotEmbed.styles';
const TrustpilotEmbed = ({ locale, businessUnitId, altText, templateId = "5419b732fbfb950b10de65e5" /* TrustpilotEmbedTemplate.MicroStar */, styleHeight, styleWidth, anchorId, inverted, }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    if (!styleHeight || !styleWidth) {
        switch (templateId) {
            case "5419b732fbfb950b10de65e5" /* TrustpilotEmbedTemplate.MicroStar */:
                styleHeight = '20px';
                styleWidth = '215px';
                break;
            case "53aa8807dec7e10d38f59f32" /* TrustpilotEmbedTemplate.Mini */:
                styleHeight = '120px';
                styleWidth = '240px';
                break;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { id: anchorId },
            React.createElement(S.Wrapper, null,
                React.createElement("div", { className: "trustpilot-widget", "data-locale": locale, "data-template-id": templateId, "data-businessunit-id": businessUnitId, "data-style-height": styleHeight, "data-style-width": styleWidth, "data-theme": inverted ? 'dark' : 'light' },
                    React.createElement("a", { href: `https://uk.trustpilot.com/review/${businessUnitId}`, target: "_blank", rel: "noopener noreferrer" }, altText))))));
};
export default TrustpilotEmbed;
